module.exports = __webpack_public_path__ + "img/emp3-3.83e7776d.jpg";